<template>
  <Btn
    v-bind="{ ...$attrs }"
    class="px-0 cursor-pointer shape-mask button-icon"
    :class="{ active }"
  >
    <slot />
  </Btn>
</template>

<script>
import Btn from '@/components/atoms/HeraFormBtn';
import { prop } from '@/utils/factories';
export default {
  name: 'BtnIcon',
  components: { Btn },
  props: {
    active: prop(Boolean),
  },
};
</script>

<style lang="scss">
button.button-icon {
  min-width: unset;
  height: 1.5rem;
  border-width: 0;
  background: $ph-input-bg;
  color: $ph-secondary-text;
  border-radius: 0;
  width: auto;
  box-shadow: none !important;
  outline: none !important;

  &.active {
    background: $ph-accent;
    color: $ph-primary-text;
  }
  .svg-icon-wrapper {
    margin: 0.25rem;
  }
}
</style>
